import listenerPage from "@/store/modules/homepage/listenerPage";

export default {
  namespaced: true,
  modules: {
    listenerPage
  }
};
